import { render, staticRenderFns } from "./DIASRealEstateLuovutettavatOsuudet.vue?vue&type=template&id=6609f119&"
import script from "./DIASRealEstateLuovutettavatOsuudet.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateLuovutettavatOsuudet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports